import Image from "../Common/Image/Image";
import "./BuyingBenefits.less";

const benefits = [
  {
    title: "Power of Compounding:",
    description: "Pension plans allow your savings to grow through the power of compounding. The interest earned is added back to your capital, which helps you earn more over time and create a larger retirement corpus. You can use a pension calculator to know how the power of compounding can help build a substantial corpus for your future.",
  },
  {
    title: "Financial Safety Net:",
    description:
      "Pension plans offer a financial safety net during retirement. They help you save and cover your post-retirement expenses, ensuring you remain financially secure.",
  },
  {
    title: "Guaranteed Regular Income for Life:",
    description:
      "Pension plans provide a guaranteed<sup>@</sup> stream of income for life. Depending on the frequency you choose, they offer regular payouts to help you maintain your financial independence in retirement.",
  },
  {
    title: "Insurance Cover:",
    description:
      "Pension plans not only build your retirement savings but also offer life insurance coverage`. This ensures that in your absence, your loved ones have a financial backup to rely upon.",
  },
  {
    title: "Tax Benefits under Section 80CCC and 10(10A):",
    description:
      "Pension plans offer tax* benefits on the premiums paid, with deductions up to ₹ 1.5 lakh under Section 80CCC* of the Income Tax Act, 1961. In addition, the commuted value of the pension you receive is exempt subject to the conditions prescribed under Section 10(10A)*.",
  },
];

const PensionBenefits = () => {
  return (
    <section className="pension-benefits">
      <div className="pension-benefits__container">
        <h2 className="pension-benefits__title">
          What are the Benefits of Buying Pension Insurance Plans
        </h2>

        <div className="pension-benefits__card">
          <div className="pension-benefits__list">
            {benefits.map((item, index) => (
              <div key={index} className="pension-benefits__item">
                <div className="pension-benefits__item-header">
                  <span className="pension-benefits__icon">
                    <Image src={"assets/planBenefitArrow.svg"} alt="planBenefitArrow" />
                  </span>
                  <h3 className="pension-benefits__item-title">{item.title}</h3>
                </div>
                <p className="pension-benefits__item-description" dangerouslySetInnerHTML={{ __html: item.description }}>
                </p>
              </div>
            ))}
          </div>
        </div>

        <p className="pension-benefits__footer">
          COMP/DOC/Sep/2025/299/1230
        </p>
      </div>
    </section>
  );
};

export default PensionBenefits;
